export class Credentials {
  constructor(
    public username: string,
    public accessToken: string,
    public refreshToken: string,
    public idToken: string,
    public roles: string[]
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/models/credentials.model.ts